import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";

export default {
    namespaced: true,
    state: {
        catalogFilter: {},
        items: [],
        nav: {},
        sort: {},
        favorites: [],
        cartData: {},
        currentItemId: null,
        requestBlocked: false,
        cartStatus: 'default',
        isFavorites: true,
    },
    mutations: {
        setCartStatus(state, value) {
            state.cartStatus = value
        },
        setCatalogFilter(state, options) {
            state.catalogFilter = options
        },
        setCatalogItems(state, items) {
            state.items = items
        },
        setCatalogNav(state, navParams) {
            state.nav = navParams
        },
        setSort(state, params) {
            state.sort = params
        },
        setFavorites(state, data) {
            state.favorites = data
        },
        setCartData(state, data) {
            state.cartData = data
        },
        setCurrentItem(state, id) {
            state.currentItemId = id;
        },
        setIsFavorites(state, value) {
            state.isFavorites = value;
        },


    },
    getters: {
        getCatalogFilter: state => state.catalogFilter,
        getCatalogItems: state => state.items,
        getCatalogNav: state => state.nav,
        getCatalogSort: state => state.sort,
        getCatalogFavorites: state => state.favorites,
        getCartData: state => state.cartData,
        getCurrentItemId: state => state.currentItemId,
        getFavorites: state => state.favorites,
        isFavorite: state => id => Object.values(state.favorites).includes(Number(id)),
        getCartCost: state => state.cartData.items?.reduce((acc, item) => {
            return acc + item.price
        }, 0),
        getOrderStep: state => state.orderStep,
        getCartStatus: state => state.cartStatus,
        getIsFavorites: state => state.isFavorites,
    },
    actions: {

        async loadFavorites({commit}) {
            commit('startLoading', 'loadFavorites', {root: true})
            let response = await Fetch('catalog/getfavorite/')
            if (response.success) {
                if (response.data.favorites) {
                    await commit('setFavorites', response.data.favorites)
                    commit('stopLoading', 'loadFavorites', {root: true})
                }
            }
        },
        async loadCartData({commit}) {
            commit('startLoading', 'loadCartData', {root: true})
            let response = await Fetch('catalog/getcart/')
            if (response.success) {
                if (response.data) {
                    await commit('setCartData', response.data)
                    commit('stopLoading', 'loadCartData', {root: true})
                }
            }
        },
        async addToCart({commit, dispatch}, id) {
            return new Promise(resolve => {
                commit('startLoading', 'addToCart', {root: true})
                let formData = new FormData();
                formData.append('productId', id);
                fetch("/api/desktop/catalog/addtocart/", {
                    method: 'POST',
                    body: formData
                }).then((response) => {
                    response.json().then(function (res) {
                        commit('stopLoading', 'addToCart', {root: true})
                        if (!res.success) {
                            let textError = "Товар не добавлен в корзину";
                            if (res.message && res.message != "") {
                                window.toast.error(textError, res.message);
                            } else {
                                window.toast.error(textError);
                            }
                            dispatch('loadCartData');
                        } else if (res.success) {
                            // window.toast.success('Товар добавлен в корзину');
                            
                            dispatch('loadCartData');
                        }
                        resolve(res);
                    });
                });
            });
        },
        async removeFromCart({commit, dispatch}, id) {
            commit('startLoading', 'removeFromCart', {root: true})
            let formData = new FormData();
            formData.append('id', id);
            fetch("/api/desktop/catalog/deletecartitem/", {
                method: 'POST',
                body: formData
            }).then((response) => {
                response.json().then(function (res) {
                    commit('stopLoading', 'removeFromCart', {root: true})
                    if (!res.success) {
                        let textError = "Ошибка удаления из корзины";
                        if (res.message && res.message != "") {
                            window.toast.error(textError, res.message);
                        } else {
                            window.toast.error(textError);
                        }
                        dispatch('loadCartData');
                    } else if (res.success) {
                        window.toast.success('Товар удален из корзины');
                        dispatch('loadCartData');
                    }
                });
            });
        },

        async toggleFavorites({commit}, id) {
            commit('startLoading', 'addToCart', {root: true})

            const body = new objectToFormData({productId: id});

            let response = await Fetch('catalog/togglefavorite/', {
                method: 'POST',
                body
            });

            if (response.data.favorites) {
                commit('setFavorites', response.data.favorites);
            }
            commit('stopLoading', 'addToCart', {root: true})
            return response;
        },


        async buyOneClick({commit}, data) {
            commit('startLoading', 'buyOneClick', {root: true})
            const body = new FormData();
            if (data.name) body.append('name', data.name);
            if (data.phone) body.append('phone', data.phone);
            if (data.id) body.append('productId', data.id);
            if (data.code) body.append('code', data.code);
            if (data.token) body.append('token', data.token);

            let response = await Fetch(`catalog/byOneClick/`,{
                method: 'POST',
                body
            });

            if (!response.success) {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'buyOneClick', {root: true})
            return response;
        },
        async cartSwapDelay({ commit, dispatch }) {
            commit('startLoading', 'swapCart', {root: true})

            let response = await Fetch(`catalog/cart/swap-delay/`, { method: 'POST' });

            if (!response.success) {
                let textError = "Ошибка";
                window.toast.error(textError, response.message || '');
            }
            commit('stopLoading', 'swapCart', {root: true})
            dispatch('loadCartData');
            return response;
        },

        async loadDeliveryListData({commit}) {
            commit('startLoading', 'loadDeliveryListData', {root: true})
            let response = await Fetch('cart/order/service-data/')
            if (response.success) {
                await commit('setPickup', response.data.pickup)
                await commit('setDeliveryTypes', response.data.delivery_types)
            }
            commit('stopLoading', 'loadDeliveryListData', {root: true})
        },
        async loadCitiesList({commit}, query) {
            let response = await Fetch(`/cart/get-cities/?q=${query || ''}`)
            if (response.success) {
                await commit('setCitiesList', response.data)
            }
           
        },

        async loadDeliveryPrice({commit}, data) {
            const body = new objectToFormData(data);

            let response = await Fetch('cart/calc-delivery/', {
                method: 'POST',
                body
            })
            if (response.success) {
                await commit('setDeliveryPrice', response.data)
            }
           
        },
        async loadDeliveryPoints({commit}, data) {
            let response = await Fetch(`cart/get-delivery-points/?type_delivery=${data.type_delivery}&city_id=${data.city_id}`, {
                method: 'GET',
            })
            if (response.success) {
                await commit('setDeliveryPoints', response.data)
            }
        },
    },
    methods: {}
}